import { useEffect, useState } from 'react';

import { load } from '#src/lib/http.ts';

export const useFetch = <T extends NonNullable<unknown> = string>(
  url: string
) => {
  const [data, setData] = useState<null | T>(null);

  useEffect(() => {
    const fetchData = async () => {
      setData(await load<T>(url));
    };

    fetchData();
  }, [url]);

  return data;
};
